import React from 'react';
import TimingVisualization from './TimingVisualization';
import FireworksDisplay from './FireworksDisplay';
import { useTheme } from './ThemeContext';

const VisualizationModal = ({ isOpen, onClose, timeArray, selectedTimeHorizon, fireWorksActive, currentScore }) => {
  const { theme, isAscii: isAnyAscii } = useTheme();
  const isDark = theme === 'dark';
  const isAscii = isAnyAscii && isDark;
  const isAsciiLight = isAnyAscii && !isDark;

  if (!isOpen) return null;

  const modalStyle = isAscii ? {
    background: '#000000', border: '2px solid #33ff33', color: '#33ff33',
    borderRadius: '0', fontFamily: '"Courier New", Courier, monospace',
  } : isAsciiLight ? {
    background: '#f2f2ee', border: '2px solid #444444', color: '#1a1a1a',
    borderRadius: '0', fontFamily: '"Courier New", Courier, monospace',
  } : isDark ? {
    background: 'rgba(8, 12, 26, 0.97)',
    border: '1px solid rgba(0, 245, 255, 0.14)',
    color: '#ddeeff',
  } : {};

  const closeButtonStyle = isAscii ? {
    color: '#33ff33', background: 'none', border: '1px solid #33ff33',
    borderRadius: '0', fontFamily: '"Courier New", Courier, monospace',
  } : isAsciiLight ? {
    color: '#1a1a1a', background: 'none', border: '1px solid #444',
    borderRadius: '0',
  } : isDark ? { color: '#8ab4cc' } : {};

  const footerButtonStyle = isAscii ? {
    background: '#000', border: '1px solid #33ff33', color: '#33ff33',
    borderRadius: '0', fontFamily: '"Courier New", Courier, monospace',
  } : isAsciiLight ? {
    background: '#1a1a1a', border: '1px solid #444', color: '#f2f2ee',
    borderRadius: '0', fontFamily: '"Courier New", Courier, monospace',
  } : isDark ? {
    backgroundColor: 'rgba(0, 100, 200, 0.55)',
    border: '1px solid rgba(0, 180, 255, 0.3)',
    color: '#00d4ff',
    boxShadow: '0 0 12px rgba(0, 180, 255, 0.2)',
  } : {};

  return (
    <>
      {/* Fireworks should be rendered outside the modal */}
      <FireworksDisplay isActive={fireWorksActive} />

      <div className="modal-overlay">
        <div className="modal-content" style={modalStyle}>
          <button className="modal-close-button" onClick={onClose} style={closeButtonStyle}>×</button>

          <div className="modal-body">
            <TimingVisualization
              timeArray={timeArray}
              selectedTimeHorizon={selectedTimeHorizon}
              currentScore={currentScore}
            />
          </div>

          <div className="modal-footer">
            <button className="modal-footer-button" onClick={onClose} style={footerButtonStyle}>
              Close
            </button>
          </div>
        </div>
      </div>

      <style jsx>{`
                .fireworks-canvas {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    pointer-events: none; /* 👈 Prevent blocking clicks */
                    z-index: 2000; /* 👈 Make sure it's above the modal */
                }

                .modal-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: rgba(0, 0, 0, 0.7);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 1000;
                }

                .modal-content {
                    background: white;
                    border-radius: 12px;
                    width: 95%;
                    max-width: 1200px;
                    max-height: 90vh;
                    position: relative;
                    overflow: auto;
                    padding: 2rem;
        }

        .modal-close-button {
          position: absolute;
          right: 1rem;
          top: 1rem;
          background: none;
          border: none;
          font-size: 1.5rem;
          cursor: pointer;
          color: #666;
          padding: 0.5rem;
          width: 2.5rem;
          height: 2.5rem;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background-color 0.2s;
        }

        .modal-close-button:hover {
          background-color: #f0f0f0;
        }

        .modal-body {
          margin-top: 1rem;
        }

        .modal-footer {
          display: flex;
          justify-content: center;
          margin-top: 2rem;
        }

        .modal-footer-button {
          padding: 0.75rem 2rem;
          background-color: #2196F3;
          color: white;
          border: none;
          border-radius: 6px;
          font-size: 1rem;
          cursor: pointer;
          transition: background-color 0.2s;
        }

        .modal-footer-button:hover {
          background-color: #1976D2;
                }
            `}</style>
    </>
  );
};

export default VisualizationModal;